import { runtimeConfig } from '@/lib/runtime-config';

export const PRODUCTS_URL = '/products';

// Base URLs
const API_BASE_URL_RAW = (
  runtimeConfig.VITE_API_BASE_URL || 'http://localhost'
).trim();
export const PORT = (runtimeConfig.VITE_API_PORT || '').trim();

function buildBaseUrl(rawBase: string, fallbackPort: string): string {
  const cleaned = rawBase.replace(/\/+$/, '');

  if (!/^https?:\/\//i.test(cleaned)) {
    return /:\d+$/.test(cleaned) || !fallbackPort
      ? cleaned
      : `${cleaned}:${fallbackPort}`;
  }

  try {
    const parsed = new URL(cleaned);
    if (!parsed.port && fallbackPort) {
      parsed.port = fallbackPort;
    }
    return parsed.toString().replace(/\/+$/, '');
  } catch {
    return cleaned;
  }
}

export const BASE = buildBaseUrl(API_BASE_URL_RAW, PORT);
// Sections
export const API = '/api';
export const ME = '/me';

// Versions
export const V1 = '/v1';

// Mailer
export const URL_MAILER = '/mailer';
export const URL_SEND_CONTACT_US = '/contact-us';
export const URL_SEND_SUPPORT_REQUEST = '/support-request';
export const URL_SEND_PLAN_RENEWAL_REQUEST = '/plan-renewal-request';

// Auth
export const AUTH = '/auth';
export const URL_REFRESH = '/refresh';
export const URL_RESET_PASSWORD = '/reset-password';
export const URL_FORGET_PASSWORD = '/forget-password';
export const REGISTER_URL = '/register';
export const URL_PERMISSION_PREVIEW = '/permission-preview';
export const URL_TRUSTED_DEVICES = '/devices';
export const URL_WEB_LOGIN_APPROVAL = '/web-login-approval';
export const URL_WEB_LOGIN_REQUESTS = '/web-login-requests';

export const CONFIRM_URL = '/confirm';

export const SIGN_IN = '/sign-in';

export const LOGIN = '/login';
export const URL_REAUTHENTICATE = '/reauthenticate';

// Fragments

export const URL_SUPPLIERS = '/suppliers';

export const URL_USERS = '/users';
export const URL_VERIFY_EMAIL = '/verify-email';
export const URL_RESEND_VERIFICATION_BY_EMAIL = '/resend-verification-by-email';

export const URL_TENANTS = '/tenants';
export const URL_MY_TENANTS = '/my-tenants';
export const URL_INVITE = '/invite';
export const URL_INVITATIONS = '/invitations';
export const URL_RESEND = '/resend';
export const URL_ACCEPT = '/accept';
export const URL_TENANT_SETTINGS = '/tenant-settings';
export const URL_TENANT_PAYMENT = '/tenant-payment';
export const URL_PLAN_HISTORY = '/plan-history';
export const URL_ACTIVE_SUBSCRIPTION = '/activeSubscription';
export const URL_UPGRADE_PRICES = '/upgradePrices';
export const URL_PLANS = '/plans';
export const URL_LOCATIONS = '/locations';
export const URL_MUNICIPALITIES = '/municipalities';
export const URL_COUNTRIES = '/countries';

// Cashflow
export const URL_COMPANIES = '/companies';
export const URL_PRODUCTS = '/products';
export const URL_PRICE_LISTS = '/price-lists';
export const URL_INVENTORY_SESSIONS = '/inventory-sessions';
export const URL_ACCOUNTS = '/accounts';
export const URL_DEBTS = '/debts';
export const URL_DSCR = '/dscr';
export const URL_CONNECT = '/connect';
export const URL_RECONNECT = '/reconnect';
export const URL_SYNC = '/sync';
export const URL_CATEGORIES = '/categories';
export const URL_CASH_MOVEMENTS = '/cash-movements';
export const URL_CASH_MOVEMENT_ALLOCATION = '/cash-movement-allocation';
export const URL_CASH_MOVEMENT_SPLITS = '/cash-movement-splits';
export const URL_DOCUMENTS = '/documents';
export const URL_FISCONLINE = '/fisconline';
export const URL_ASSIGN_APPOINTEE = '/assign-appointee';
export const URL_UNLINK_APPOINTEE = '/unlink-appointee';
export const URL_ACTIVATE_ACUBE_DELEGATION = '/activate-acube-delegation';
export const URL_DEACTIVATE_ACUBE_DELEGATION = '/deactivate-acube-delegation';
export const URL_FORECAST_SERIES = '/forecast-series';
export const URL_FORECAST_OCCURRENCES = '/forecast-occurrences';
export const URL_FORECAST_SCENARIOS = '/forecast-scenarios';
export const URL_FORECAST_PAYMENT_SCHEDULES = '/forecast-payment-schedules';
export const URL_PAYMENT_SCHEDULES = '/payment-schedules';
export const URL_RECONCILIATION = '/reconciliation';
export const URL_SUBSCRIBE = '/subscribe';
export const URL_UNSUBSCRIBE = '/unsubscribe';
export const URL_REACTIVATE = '/reactivate';
export const URL_CREDENTIALS = '/credentials';
export const URL_ACTIVATE_SCHEDULE = '/activate-schedule';
export const URL_DEACTIVATE_SCHEDULE = '/deactivate-schedule';
export const URL_DOWNLOAD_ARCHIVE = '/download-archive';
export const URL_IMPORT = '/import';
export const URL_UNLINK = '/unlink';
export const URL_BANK_IMPORT = '/bank-import';
export const URL_IMPORT_TEMPLATES = '/import-templates';
export const URL_PARSE = '/parse';
export const URL_PREVIEW = '/preview';
export const URL_XML = '/xml';
export const URL_PDF = '/pdf';
export const URL_PAPER_PREVIEW = '/paper-preview';

// Electronic invoicing (FatturaPA)
// NB: il backend monta il controller su `tenants/:tenantId/vat-rates`
// (vedi TenantVatRatesController @Controller('tenants/:tenantId/vat-rates')).
// L'URL costante deve combaciare per evitare 404 silenzioso sul GET delle
// aliquote IVA per tenant.
export const URL_TENANT_VAT_RATES = '/vat-rates';
export const URL_TENANT_UNITS_OF_MEASURE = '/units-of-measure';
export const URL_TENANT_PAYMENT_METHODS = '/payment-methods';
export const URL_DOCUMENT_LINES = '/lines';
export const URL_DOCUMENT_WITHHOLDING = '/withholding';
export const URL_DOCUMENT_SOCIAL_SECURITY = '/social-security';
export const URL_DOCUMENT_REFERENCES = '/references';

export const RESEND_EMAIL_VERIFICATION = '/email-confirm-resend-code';

//reconciliation
export const URL_AUTO_MATCH = '/auto-match';
export const URL_AUTO_MATCH_CASH = '/auto-match-cash';
export const URL_AUTO_MATCH_CASH_ASYNC = '/auto-match-cash/async';
export const URL_RECONCILIATION_PROPOSAL_RUNS = '/proposal-runs';
export const URL_AUTO_MATCH_SCHEDULE = '/auto-match-schedule';
export const URL_ANALYTICS = '/analytics';
export const URL_PENDING = '/pending';
export const URL_PROPOSED = '/proposed';
export const URL_PROPOSED_CASH = '/proposed-cash';
export const URL_SCHEDULE = '/schedule';
export const URL_SCHEDULES = '/schedules';
export const URL_SHORTFALL_RESOLUTION = '/shortfall-resolution';
export const URL_REJECT = '/reject';
export const URL_REJECT_ALL = '/reject-all';
export const URL_CONFIRM_GROUP = '/confirm-group';
export const URL_REJECT_GROUP = '/reject-group';
export const URL_REJECT_ALL_CASH = '/reject-all-cash';
export const URL_AUTOFATTURA_GROUPS = '/autofattura-groups';
export const URL_OCCURRENCE = '/occurrence';
export const URL_MANUAL_LINK = '/manual-link';
export const URL_REMOVE_GROUP = '/remove-group';

// Notifications
export const URL_NOTIFICATIONS = '/notifications';

// Onboarding
export const URL_ONBOARDING = '/onboarding';

// Payments (SEPA)
export const URL_PAYMENTS = '/payments';
export const URL_SEPA_PAYMENTS = '/sepa-payments';

// Internal Transfers (Giroconti)
export const URL_INTERNAL_TRANSFERS = '/internal-transfers';
export const URL_ACCOUNT_TRANSFERS = '/account-transfers';
export const URL_DETECT = '/detect';
export const URL_DISTINTE_RIBA = '/distinte-riba';
export const URL_PAYROLL_IMPORT = '/payroll-import';
export const URL_PAYSLIPS = '/payslips';
export const URL_EXTRACT = '/extract';
export const URL_PAYMENT_METHOD = '/payment-method';
export const URL_SETUP_INTENT = '/setup-intent';

// MCP - Model Context Protocol (OAuth)
export const URL_MCP = '/mcp';
export const URL_MCP_CONNECTIONS = '/connections';
export const URL_MCP_CLIENT_POLICY = '/client-policy';

// Public contract signing (no auth, token in path)
export const URL_PUBLIC = '/public';
export const URL_CONTRACTS = '/contracts';
export const URL_REQUEST_OTP = '/request-otp';
export const URL_SIGN = '/sign';
export const URL_REGISTRY_DATA = '/registry-data';

// Public work report document (no auth, token in path)
export const URL_WORK_REPORTS = '/work-reports';
export const URL_VERSIONS = '/versions';

// Advisor (Pannello Commercialista)
export const URL_ADVISOR = '/advisor';
export const URL_ADVISOR_STATUS = '/status';
export const URL_ADVISOR_PROFILE = '/profile';
export const URL_ADVISOR_CLIENTS = '/clients';
export const URL_ADVISOR_OPEN = '/open';

// F24 (CGN Fintech)
export const URL_F24 = '/f24';
export const URL_F24_IMPORT = '/import';
export const URL_F24_JOBS = '/jobs';
export const URL_F24_CONFIRM = '/confirm';
export const URL_F24_CONSOLIDATE = '/consolidate';
export const URL_F24_AUTHORIZATION_PDF = '/authorization-pdf';
export const URL_F24_CONSENT = '/consent';
export const URL_F24_PAY = '/pay';
export const URL_F24_RETRY = '/retry';

// Cassetto fiscale — modelli F24 dell'Agenzia
export const URL_ACUBE_F24_FORMS = '/acube-f24-forms';
export const URL_ACUBE_F24_LINK = '/link';
export const URL_ACUBE_F24_IMPORT = '/import';
export const URL_ACUBE_F24_RECEIPT = '/receipt';

// Support Tickets
export const URL_SUPPORT_TICKETS = '/support-tickets';
export const URL_SUPPORT_MESSAGES = '/messages';
export const URL_SUPPORT_STATUS = '/status';
export const URL_SUPPORT_ATTACHMENTS = '/attachments';
export const URL_SUPPORT_DOWNLOAD = '/download';

// [Tecnos/Gestify] Slot formazione e upload presigned: dormienti.
export const URL_SUPPORT_SLOTS_DAYS = '/slots/days';
export const URL_SUPPORT_SLOTS_HOURS = '/slots/hours';
export const URL_SUPPORT_ATTACHMENT_REQUEST = '/request';
export const URL_SUPPORT_ATTACHMENT_FINALIZE = '/finalize';
